import React from 'react';

// Components
import InputWrapper from '../InputWrapper';
import Radio from './Radio';

interface RadioItem {
  value: string;
  label?: React.ReactNode;
}

type RadioGroupChangeEvent = {
  target: {
    name?: string;
    value: string;
  };
};

type RadioGroupBlurEvent = {
  target: {
    name?: string;
  };
};

interface Props {
  label?: string;
  error?: React.ReactNode;
  name?: string;
  radioList?: RadioItem[];
  isMandatory?: boolean;
  disabled?: boolean;
  onChange: (e: RadioGroupChangeEvent) => void;
  onBlur: (e: RadioGroupBlurEvent) => void;
  value?: string;
}

const RadioGroup: React.FC<Props> = ({
  label,
  error,
  name,
  radioList,
  isMandatory,
  disabled,
  onChange,
  onBlur,
  value,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({
      target: {
        name,
        value: e.target.value,
      },
    });
  };

  const handleBlur = () => {
    onBlur({
      target: {
        name,
      },
    });
  };

  return (
    <InputWrapper label={label} error={error} isMandatory={isMandatory}>
      <div className="input-wrapper__radio-group">
        {radioList &&
          radioList.map((item) => {
            return (
              <Radio
                key={item.value}
                name={name}
                value={item.value}
                checked={item.value === value}
                onChange={handleChange}
                onBlur={handleBlur}
                label={item.label}
                disabled={disabled}
              />
            );
          })}
      </div>
    </InputWrapper>
  );
};

export default RadioGroup;
